import { atBqnTarget, parseClusterResponse } from "common/api";

const warningBillingDisabledRE = /%WARN-ENOENT: Billing API disabled/;

const labelAndValueFrom = (row) => {
  const [label, value] = row.trim().split(/: /);
  return { label, value };
};

const extractFacts = (input) =>
  input
    .trim("\n")
    .split("\n")
    .flatMap((row) => (row.length === 0 ? [] : [labelAndValueFrom(row)]));

export const parseBillingStatus = (input) =>
  input.match(warningBillingDisabledRE) ? null : extractFacts(input);

export const isSyncDone = (facts) => {
  if(!facts){
    return false;
  }

  const syncEndedFact = facts.find(({ label }) => label === "Sync in progress");
  return syncEndedFact === undefined || syncEndedFact.value !== "no"
    ? false
    : true;
};

const parseMoment = (input) => new Date(input.trim("\n"));

// The status of the BQN selected in the header, or of the whole cluster. Every
// response reports the BQN of its status, so the section is the one it belongs
// to, and bqnIdShown is only the BQN of a response reporting none.
// The status out of the output of the command, which a caller that asks for
// it with others in a batch parses with this. A BQN with the billing API off
// reports no status at all.
export const parseBillingStatusDetail = (response, bqnIdShown) =>
  response.match("Billing API disabled")
    ? null
    : parseClusterResponse(response, parseBillingStatus, bqnIdShown);

export const requestBillingStatus = (mode, bqnId, bqnIdShown) =>
  ifCl
    .run(atBqnTarget("show api billing status detail", mode, bqnId))
    .then((response) => parseBillingStatusDetail(response, bqnIdShown));

// The date of the BQN selected in the header.
export const requestMoment = (mode, bqnId) =>
  ifCl.run(atBqnTarget("show system date", mode, bqnId)).then(parseMoment);

// The whole cluster reports every BQN under its own section, so there is no
// BQN to attribute the status to.
const bqnIdOfStatus = (bqnId) => (bqnId === "all" ? undefined : bqnId);

export const requestFactsAndMoment = (mode, bqnId) =>
  Promise.all([
    requestMoment(mode, bqnId),
    requestBillingStatus(mode, bqnId, bqnIdOfStatus(bqnId)),
  ]).then(([moment, facts]) => ({
    moment,
    facts,
  }));

const disconnectAndConnect = () =>
  ifCl
    .run(`api billing disconnect`)
    .then(() => ifCl.run("api billing connect"));

const warnBusyAndReturnData = (callback, data) => {
  try {
    callback();
  } catch (error) {
    console.warn("failed to run warning callback");
  }
  return data;
};

export const reconnect = (warningCallback, mode, bqnId) =>
  requestFactsAndMoment(mode, bqnId).then(({ moment, facts }) => {
    const ready = facts !== null ? Object.values(facts).every(isSyncDone) : false;
    return ready === true
      ? disconnectAndConnect().then(() => requestFactsAndMoment(mode, bqnId))
      : warnBusyAndReturnData(warningCallback, { ready, moment, facts });
  });
